import { cva, VariantProps } from 'class-variance-authority'
import { PropsWithChildren, RefObject } from 'react'

import { cn } from '@/shared/lib'

const contentBoxVariants = cva(
  'typo-label2 rounded-sm font-normal text-black',
  {
    variants: {
      spacing: {
        small: 'px-3 py-1.5',
        medium: 'p-4',
        large: 'p-6',
      },
      color: {
        'light-gray': 'bg-gray-0',
        gray: 'bg-gray-50',
        purple: 'bg-purple-50',
      },
      align: {
        left: 'flex justify-start',
        center: 'flex justify-center',
        right: 'flex justify-end',
        between: 'flex justify-between',
      },
    },
  },
)

type Props = VariantProps<typeof contentBoxVariants> & {
  className?: string
  ref?: RefObject<HTMLDivElement | null>
}

export const ContentBox = ({
  spacing = 'small',
  color = 'gray',
  align,
  className,
  ref,
  children,
}: PropsWithChildren<Props>) => {
  return (
    <div
      className={cn(contentBoxVariants({ spacing, color, align, className }))}
      ref={ref}
    >
      {children}
    </div>
  )
}
